import React from "react";
import pdf from "~/assets/documents/TERMO_DE_USO_PORTAL_DE_FORNECEDORES_05.11.2019.pdf";
import "./AcceptanceTerm.scss"

const AcceptanceTerm = (props) => {
	return <embed src={pdf} className="embed-pdf"/>;
};

export default AcceptanceTerm;
